import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { roleTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const createRole: roleTypes.CreateRole = (data) => {
  return axios.post('/roles', data);
};

type UseCreateRoleOptions = {
  config?: MutationConfig<typeof createRole>;
};

export function useCreateRole({ config = {} }: UseCreateRoleOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      toasts.loadingToast.loading('create-role', 'Creating role...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['roles']);
      toasts.loadingToast.success('create-role', 'Role created successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('create-role', serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: createRole,
  });
}
